import { web3Actions } from "./web3.action";
import { userActions } from "./user.action";
import { adminActions } from "./admin.action";
import { amenitiesActions } from "./amenities.action";

type ActionType = typeof web3Actions &
  typeof userActions &
  typeof adminActions &
  typeof amenitiesActions;

export const actions: ActionType = {
  ...web3Actions,
  ...userActions,
  ...adminActions,
  ...amenitiesActions,
};
